export { default as ContentfulResponsiveImages } from './contentfulResponsiveImages'



// WEBPACK FOOTER //
// ./src/modules/contentful/responsive/images/index.js